import { Suspense } from "react";
import { Outlet } from "react-router";
import { useAuth } from "@/lib/auth-context";
import { RouteFallback } from "@/components/shared/route-fallback";
import { PortalTopNav } from "./portal-top-nav";
import { PreviewAsBanner } from "./preview-as-banner";

// Ports /app/portal/layout.tsx — sticky top nav, optional preview-as banner,
// max-width content shell with a small footer. The PreviewAsBanner renders
// itself only when an internal user has an active preview-as session, so the
// banner gate lives in the component (not here).
export function PortalLayout() {
  const { session } = useAuth();
  if (!session) return null;

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <PreviewAsBanner />
      <PortalTopNav email={session.email} fullName={session.fullName} />
      <main className="mx-auto w-full max-w-[1100px] flex-1 px-6 py-8">
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </main>
      <footer className="mx-auto w-full max-w-[1100px] border-t px-6 py-6 text-[11px] text-muted-foreground">
        Colab · Bookboost partner portal
      </footer>
    </div>
  );
}
